import formatters from '@/common/format';
import helpers from '@/common/helpers';

export default function () {
    return {
        install(Vue) {
            Object.entries(formatters).forEach(([name, filter]) => Vue.filter(name, filter));
            Object.entries(helpers).forEach(([name, filter]) => Vue.filter(name, filter));
        },
    };
}
